import { SANDBOX_BANNER_ID } from '../../external-contrib/sandbox-banner/constants/constants';
export function getRootNavSandboxBannerHeight() {
  const sandboxBannerContainer = document.getElementById(SANDBOX_BANNER_ID);
  const sandboxBannerContainerHeight = sandboxBannerContainer ? sandboxBannerContainer.getBoundingClientRect().height : 0;
  return sandboxBannerContainerHeight;
}